module.exports = __webpack_public_path__ + "img/notebook.d12687a2.png";